import React from 'react';
import { Route, Switch } from 'react-router-dom';

const AppContainer = React.lazy(() => import('../container/AppContainer/AppContainer'));

const ControllerRouter = () => (
    <Switch>
        <Route key="app" path={'/'} component={AppContainer} />
    </Switch>
);

export default ControllerRouter;
